/**
 * Vuex module for contact personal tags
 */
import debug from 'debug'
import API from '@/api'
import PersonalTag from 'Store/class/contact/personal_tag'
import events from 'Store/events'

const dbg = debug('store:contactPersonalTag:')

const actions = {
  get ({ commit, state }) {
    dbg('Getting contact personal tags')
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    return new Promise((resolve, reject) => {
      return API.getContactPersonalTags()
        .then(response => {
          commit('ADD_PERSONAL_TAGS', response.data)
          resolve()
        })
        .catch(err => {
          dbg(err)
          const msg = API.getException(err) || 'Failed to get contact personal tags'
          events.pubError(msg)
          reject(err)
        })
    })
  },

  create ({ commit }, data) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    const tag = new PersonalTag(data)
    commit('NEW_PERSONAL_TAG', tag)
  },

  update ({ commit }, data) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    const tag = new PersonalTag(data)
    commit('UPDATE_PERSONAL_TAG', tag)
  },

  delete ({ commit }, data) {
    if (import.meta.env.NODE_ENV === 'test') {
      return true
    }
    const tag = new PersonalTag(data)
    commit('DELETE_PERSONAL_TAG', tag)
  }
}

const mutations = {
  ADD_PERSONAL_TAGS (state, data) {
    const personalTags = []
    data.forEach(personalTag => {
      personalTags.push(new PersonalTag(personalTag))
    })
    state.personalTags = personalTags
  },

  NEW_PERSONAL_TAG (state, tag) {
    API.createContactPersonalTag(tag).then(resp => {
      this.dispatch('contacts/personalTags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to create contact personal tag')
    })
  },

  UPDATE_PERSONAL_TAG (state, tag) {
    API.updateContactPersonalTag(tag).then(resp => {
      this.dispatch('contacts/personalTags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to update contact personal tag')
    })
  },

  DELETE_PERSONAL_TAG (state, tag) {
    API.deleteContactPersonalTag(tag).then(resp => {
      this.dispatch('contacts/personalTags/get')
      this.dispatch('contacts/get')
    }).catch(err => {
      dbg(err.response)
      events.pubError(API.getException(err) || 'Failed to delete contact personal tag')
    })
  }
}

const state = {
  personalTags: []
}

const getters = {
  personalTags: state => state.personalTags
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
